export const MAIN_SECTION = 'main';

export const DETAILS_SECTION = 'details';

export const SALES_QUOTATION_LIST_EXPORT_ID = 'sales-quotation-list';
export const SALES_QUOTATION_LIST_TITLE = 'Listado de cotizaciones';

export const SALES_CHANGE_ITEM_LIST_EXPORT_ID = 'sales-change-item-list';
export const SALES_CHANGE_ITEM_LIST_TITLE = 'Listado de cambios de Prod.';

export const SALES_RETURN_LIST_EXPORT_ID = 'sales-return-list';
export const SALES_RETURN_LIST_TITLE = 'Listado de devolución de Prod.';

export const MAIN_SECTION_LOCALIZED_PROPERTIES = {
  trip: 'Viaje',
  status: 'Estado',
  statusERP: 'Estado ERP',
  route: 'Ruta',
  user: 'Usuario',
  responsibleCode: 'Cod. Responsable',
   responsible: 'Responsable',
  clientCode:' Cod. Cliente',
  client: 'Cliente',
  NIT: 'NIT',
  serial: 'Nro. Doc.',
  externalCode: 'Nro. Doc. Externo',
  codeClass:'Cod. Clase',
  class: 'Clase',
  createDateTimeDate: 'Fecha de Creación',
  createDateTimeHour: 'Hora de Creación',
  updateAuditAtDate: 'Fecha de Modificación',
  updateAuditAtHour: 'Hora de Modificación',
  updatedByUser: 'Usuario de Modificación',
  destinationCode: 'Cod. Destinatario',
  destination: 'Destinatario',
  address: 'Dirección',
  expeditionCondition: 'Clase de Expedición',
  paynmentConditionCod: 'Cod. Condición de Pago',
  paymentCondition: 'Condición de Pago',
  note: 'Nota',
  loadDateTime: 'Fecha de Carga',
  deliveryDateTime: 'Fecha de Entrega',
  extraStatusERPGlobal: 'Estado Global',
  extraStatusERPReject: 'Estado de rechazo',
  extraStatusERPDelivery: 'Estado de entrega',
  extraStatusERPCredit: 'Estado de crédito',
  extraStatusERPInvoice: 'Estado de factura',
  extraStatusERPUser: 'Estado de usuario',
  subtotal: 'Subtotal',
  totalSurcharges: 'Recargo',
  totalDiscounts: 'Descuento',
  totalTaxes: 'Impuesto',
  total: 'Total',
};

export const DETAILS_SECTION_LOCALIZED_PROPERTIES = {
  serial: 'Nro. Doc.',
  externalCode: 'Nro. Doc. Externo',
  sourceDocument: 'Nro. Doc. Origen',
  nextDocument: 'Nro. Doc. Destino',
  trip: 'Viaje',
  materialCode: 'Cod. Material',
  material: 'Material',
  note: 'Nota',
  warehouse: 'Almacén',
  soldQuantity: 'Cantidad (UM)',
  stockConfirmedERP: 'Cant. Confirmada',
  externalQuantity: 'Cant. Entregada',
  externalDocument: '# Doc. Entrega',
  externalPrice: 'Precio Facturado',
  externalDiscount: 'Desc. Factura',
  invoice: '# Factura',
  price: 'Precio',
  subtotal: 'SubTotal',
  totalSurcharges: 'Recargo',
  totalDiscounts: 'Descuento',
  totalTaxes: 'Impuesto',
  total: 'Total',
};
